import axios from 'axios';

import {API_URL} from './constants';

const getDate = async (): Promise<{iso: string, ms: number}> => {
    const response = await axios.post(`${API_URL}/info/date?local-iso=${new Date().toISOString()}`);
    return response.data;
};

export const infoApi = {
    getDate
};